import { useMemo, useState } from 'react'

import { Column } from 'react-table'

import { Letter } from 'state/letter/types'
import { useGetAllLettersRequest } from 'state/letter/hooks'

import { Table } from 'components/ui'

import { FullName, Email, Location, CreatedAt, Link, Delete } from './Cells'

const LIMIT = 10

function LettersTable() {
  const [page, setPage] = useState(1)
  const { data, isLoading } = useGetAllLettersRequest(page, LIMIT)

  const rows = data?.items ?? []
  const lastPage = data?.totalPages ?? 0

  const columns: Column<Letter>[] = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'firstName',
        Cell: FullName,
      },
      {
        Header: 'Email',
        accessor: 'email',
        Cell: Email,
      },
      {
        Header: 'Location',
        accessor: 'city',
        Cell: Location,
      },
      {
        Header: '',
        accessor: 'id',
        Cell: Delete,
      },
      {
        Header: 'Created',
        accessor: 'createdAt',
        Cell: CreatedAt,
      },
      {
        Header: 'Link',
        accessor: 'link',
        Cell: Link,
      },
    ],
    [],
  )

  return (
    <Table<Letter>
      showText
      data={rows}
      page={page}
      type='letters'
      title='Letters'
      onPage={setPage}
      name='lettersTable'
      columns={columns}
      lastPage={lastPage}
      isLoading={isLoading}
    />
  )
}

export { LettersTable }
